module.exports = __webpack_public_path__ + "img/CS26Q-中_12.f7fc47d8.jpg";